<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-2">
      <div class="tw-flex tw-space-x-3">
        <div
          class="
            tw-border
            tw-h-32
            tw-w-48
            tw-rounded-lg
            tw-p-1
            tw-bg-white
            tw-overflow-hidden
            tw-relative
          "
          @mouseover="() => (showBrowseFileBotton = true)"
          @mouseleave="() => (showBrowseFileBotton = false)"
        >
          <img
            :src="logo_file_src"
            alt=""
            class="tw-object-contain tw-w-full tw-h-full"
          />
          <div
            class="
              tw-w-full
              tw-h-full
              tw-opacity-30
              tw-bg-gray-600
              tw-absolute
              tw-top-0
              tw-left-0
              tw-transform
              tw-duration-500
            "
            v-show="showBrowseFileBotton"
          ></div>
          <div
            class="
              tw-w-full
              tw-h-full
              tw-absolute
              tw-top-0
              tw-left-0
              tw-flex
              tw-justify-center
              tw-items-center
            "
            v-show="showBrowseFileBotton"
          >
            <label
              for="logo-image"
              class="
                tw-text-white
                tw-p-2
                tw-bg-blue-500
                tw-opacity-100
                tw-cursor-pointer
                tw-rounded-lg
              "
              >{{ $t("browseFile") }}</label
            >
            <input
              type="file"
              id="logo-image"
              ref="logoimage"
              style="display: none"
              @change="onFileChange"
            />
          </div>
        </div>
        <div class="tw-w-full">
          <div class="row tw-space-y-2">
            <div class="col-md-12 tw-space-y-1">
              <label>{{ $t("companyProfile.nameKH") }}</label>
              <input
                v-model="model.company_name_kh"
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': errors.has('company_name_kh'),
                }"
                :placeholder="$t('companyProfile.nameKH')"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('company_name_kh')"
              >
                {{ errors.first("company_name_kh") }}
              </div>
            </div>
            <div class="col-md-12 tw-space-y-1">
              <label class="required">{{ $t("companyProfile.nameEN") }}</label>
              <input
                v-model="model.company_name_en"
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': errors.has('company_name_en'),
                }"
                :placeholder="$t('companyProfile.nameEN')"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('company_name_en')"
              >
                {{ errors.first("company_name_en") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label class="required">{{ $t("companyProfile.prefixCode") }}</label>
          <input
            v-model="model.prefix_code"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('prefix_code') }"
            :placeholder="$t('companyProfile.prefixCode')"
          />
          <div class="invalid-feedback" v-if="errors.has('prefix_code')">
            {{ errors.first("prefix_code") }}
          </div>
        </div>
        <div class="col-6 tw-space-y-1">
          <label class="required">{{ $t("companyProfile.phone") }}</label>
          <input
            v-model="model.phone"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('phone') }"
            :placeholder="$t('companyProfile.phone')"
          />
          <div class="invalid-feedback" v-if="errors.has('phone')">
            {{ errors.first("phone") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("companyProfile.email") }}</label>
          <input
            v-model="model.company_email"
            type="email"
            class="form-control"
            :class="{ 'is-invalid': errors.has('company_email') }"
            :placeholder="$t('companyProfile.email')"
          />
          <div class="invalid-feedback" v-if="errors.has('company_email')">
            {{ errors.first("company_email") }}
          </div>
        </div>
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("companyProfile.website") }}</label>
          <input
            v-model="model.company_website"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('company_website') }"
            :placeholder="$t('companyProfile.website')"
          />
          <div class="invalid-feedback" v-if="errors.has('company_website')">
            {{ errors.first("company_website") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("companyProfile.facebookPage") }}</label>
          <input
            v-model="model.facebook_page"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('facebook_page') }"
            :placeholder="$t('companyProfile.facebookPage')"
          />
          <div class="invalid-feedback" v-if="errors.has('facebook_page')">
            {{ errors.first("facebook_page") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label>{{ $t("companyProfile.address") }}</label>
          <textarea
            v-model="model.company_address"
            rows="3"
            class="form-control"
            :placeholder="$t('companyProfile.address')"
            :class="{ 'is-invalid': errors.has('company_address') }"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.has('company_address')">
            {{ errors.first("company_address") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t("save")
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
export default {
  name: "companyForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      logo_file: "",
      logo_file_src: require("../../../assets/default-image.jpg"),
      model: {
        company_id: null,
        prefix_code: null,
        company_name_kh: null,
        company_name_en: null,
        company_address: null,
        phone: null,
        company_email: null,
        company_website: null,
        company_logo: null,
        facebook_page: null,
      },
    };
  },
  computed: {
    ...mapState("corporate/companyProfile", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  created() {
    this.setEditData();
  },
  methods: {
    onFileChange() {
      const file = this.$refs.logoimage.files[0];
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.logo_file_src = reader.result;
        }.bind(this),
        false
      );
      if (file) {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          reader.readAsDataURL(file);
          this.logo_file = file;
        } else {
          this.logo_file_src = require("../../../assets/default-image.jpg");
          this.$toasted.error("invalid file type!");
          this.$refs.logo_file.value = "";
        }
      }
    },
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("corporate/companyProfile/store", this.model)
        .then(async (response) => {
          await this.uploadLogo(response.company_id);
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("corporate/companyProfile/update", {
          id: this.model.company_id,
          data: this.model,
        })
        .then(async (response) => {
          await this.uploadLogo(this.model.company_id);
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.company_id = this.edit_data.company_id;
        this.model.prefix_code = this.edit_data.prefix_code;
        this.model.company_name_kh = this.edit_data.company_name_kh;
        this.model.company_name_en = this.edit_data.company_name_en;
        this.model.company_address = this.edit_data.company_address;
        this.model.phone = this.edit_data.phone;
        this.model.company_email = this.edit_data.company_email;
        this.model.company_website = this.edit_data.company_website;
        this.model.facebook_page = this.edit_data.facebook_page;
        this.model.company_logo = this.edit_data.company_logo;
        if (this.edit_data.company_logo) {
          this.logo_file_src = this.edit_data.company_logo;
        }
      }
    },
    async uploadLogo(companyId) {
      if ((this.logo_file instanceof File) | Blob) {
        let formData = new FormData();
        formData.append("file", this.logo_file);
        formData.append("company_id", companyId);
        let response = await this.$store.dispatch(
          "corporate/companyProfile/upload",
          formData
        );
        this.model.company_logo = response;
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
</style>